import {
  ExaminationNumbers,
  ScreeningSextants,
} from '@/pages/ScreeningPage/examinationModel'
import { ModifiedBleedingNumbers } from '@/pages/ScreeningPage/modifiedIndexBleedingModel'
import {
  ExaminationModelResponse,
  ModifiedIndexBleedingModelResponse,
} from './screeningController'

export type CellsIDS = 0 | 1 | 2 | 3 | 4 | 5

const sextantsValues: ScreeningSextants[] = ['I', 'II', 'III', 'IV', 'V', 'VI']
const numberValues: ModifiedBleedingNumbers[] = [
  '16',
  '21',
  '24',
  '44',
  '41',
  '36',
]
const numbersValues: ExaminationNumbers[] = [
  '14-17',
  '13-23',
  '24-27',
  '34-37',
  '33-43',
  '44-47',
]

export abstract class ScreeningModel {
  public readonly id: CellsIDS
  public readonly sextant: ScreeningSextants
  public readonly number: ModifiedBleedingNumbers
  public readonly numbers: ExaminationNumbers

  protected constructor(id: CellsIDS) {
    this.id = id

    this.number = numberValues[id]
    this.numbers = numbersValues[id]
    this.sextant = sextantsValues[id]
  }

  public abstract getCellForSend():
    | ModifiedIndexBleedingModelResponse
    | ExaminationModelResponse
}
